import React from 'react';
import './index.css';

import App from './App';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import ThemeContextProvider from "./Context/ThemeContext";
import { getCarrinho } from './redux/cartReducer';
import { getProductsLists } from './pages/Loja/products';
import { getUsersLists } from './redux/userReducer';
import { getPostsLists } from './redux/blogReducer';

// Pré-carrega dados no store
store.dispatch(getCarrinho());
store.dispatch(getProductsLists());
store.dispatch(getUsersLists());
store.dispatch(getPostsLists());

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Provider store={store}>
      <ThemeContextProvider>
        <App />
      </ThemeContextProvider>
    </Provider>
  </BrowserRouter>
);
